import React, { useState, useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material';

const QRScanner = ({ open, onClose, onScan }) => {
  const [error, setError] = useState('');
  const [scanner, setScanner] = useState(null);

  useEffect(() => {
    if (open) {
      // Wait for the DOM element to be available
      const timer = setTimeout(() => {
        const element = document.getElementById('qr-reader');
        if (!element) {
          console.error('QR reader element not found');
          return;
        }

        const html5QrcodeScanner = new Html5QrcodeScanner(
          'qr-reader',
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            aspectRatio: 1.0
          },
          false
        );

        html5QrcodeScanner.render(
          (decodedText) => {
            try {
              const data = JSON.parse(decodedText);
              onScan(data);
              html5QrcodeScanner.clear().catch(console.error);
              onClose();
            } catch (err) {
              // If not JSON, treat as serial number
              onScan({ serialNumber: decodedText });
              html5QrcodeScanner.clear().catch(console.error);
              onClose();
            }
          },
          (errorMessage) => {
            // Scanner error - can be ignored for most cases
            console.log('Scanner error:', errorMessage);
          }
        );

        setScanner(html5QrcodeScanner);
      }, 100);

      return () => {
        clearTimeout(timer);
        if (scanner) {
          scanner.clear().catch(console.error);
        }
      };
    }
  }, [open, onScan, onClose]);

  const handleClose = () => {
    if (scanner) {
      scanner.clear().catch(console.error);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Scan QR Code</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box sx={{ my: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Position the QR code within the frame to scan
          </Typography>
          <Box id="qr-reader" sx={{ mt: 2 }} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRScanner;
